import React from "react";
import { Button } from "@mui/material";
import ReportFilter from "./ReportFilter";
import ReportsLayout from "./ReportsLayout";

export const Reports = ({
  timeZone,
  loading,
  isDropdownVisible,
  setIsDropdownVisible,
  handleGenerateReport,
  isChart,
  clickedButton,
  readyDownload,
  handleDownloadClicked,
  rawData,
  onDownloadData,
  columnVisibilityModel,
  setColumnVisibilityModel,
  showReport,
  dataGridRef,
}) => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <div>
        <ReportFilter
          isDropdownVisible={isDropdownVisible}
          setIsDropdownVisible={setIsDropdownVisible}
        />
      </div>
      {/* Move buttons to top level, outside of scrollable area */}
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "clamp(20px, 5vw, 50px)",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Button
            variant={"contained"}
            color={"primary"}
            style={{ fontSize: "12px" }}
            onClick={handleGenerateReport}
          >
            {isChart ? "Generate Chart" : "Generate Report"}
          </Button>
          <Button
            variant={"contained"}
            color={"primary"}
            sx={{
              display: clickedButton === "Pie-chart" ? "none" : "flex",
              fontSize: "12px",
            }}
            disabled={!readyDownload}
            onClick={() => handleDownloadClicked()}
          >
            {isChart ? "Download Chart" : "Download Report"}
          </Button>
        </div>
        <hr
          style={{
            border: "none",
            borderTop: "2px dotted #8e9eab",
            margin: "5px 0",
            height: "1px",
          }}
        />
      </div>

      {/* Reports content area */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
          id="chart-container"
        >
          {showReport && (
            <ReportsLayout
              dataGridRef={dataGridRef}
              clickedButton={clickedButton}
              rawData={rawData}
              onDownloadData={onDownloadData}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              loading={loading}
              timeZone={timeZone}
            />
          )}
        </div>
      </div>
    </div>
  );
};
